import { render, staticRenderFns } from "./SetAuto.vue?vue&type=template&id=211f2ace&scoped=true&"
import script from "./SetAuto.vue?vue&type=script&lang=ts&"
export * from "./SetAuto.vue?vue&type=script&lang=ts&"
import style0 from "./SetAuto.vue?vue&type=style&index=0&id=211f2ace&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211f2ace",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VCardTitle,VChip,VChipGroup,VImg})
